export const textField = {
  label1:
    'Il Cliente sottoscrivendo per adesione la presente proposta accetta che in relazione alla fornitura di ',
  label2: 'a lui intestata verrà applicata la nuova Tipologia Offerta: Accendi',
  label3: 'con riferimento CTE: ',
  label3a: 'la cui data di decorrenza nuova offerta sarà il ',
  label3b: 'e richiede che venga applicata la periodicità di fatturazione',
};



// WEBPACK FOOTER //
// ./src/app/components/alg-change-plan/alg-change-plan-customer-subscription/change-plan-customer-subscription.ts